"use strict";

var ApiHelper = require("./ApiHelper");
var QueryStringHelper = require("./QueryStringHelper");

// HistoryHelper
module.exports = {
	getQueryObject() {
		var currentQueryString = window.location.search;
		if (currentQueryString) {
			currentQueryString = currentQueryString.substring(1);
		}
		var currentQueryObject = QueryStringHelper.createObjectFromQueryString(currentQueryString) || {};
		return currentQueryObject;
	},

	handlePopState: function (executeAction, shouldShortCircuit) {
		//If we have come to the page and there is no query string, we should just reload the page itself, in its starting format
		if (!window.location.search) {
			window.location.reload();
		} else {
			//We need to reload affected components
			var query = window.location.search;
			if (query) {
				query = query.substring(1);
				var currentQueryObject = QueryStringHelper.createObjectFromQueryString(query) || {};

				if ((typeof shouldShortCircuit === "function") && shouldShortCircuit(currentQueryObject)) {
					return;
				}
				var shouldExecute = false;
				var additionalOptions = {doNotPushState: true};
				if (currentQueryObject.id) {
					additionalOptions[currentQueryObject.id] = currentQueryObject;
					shouldExecute = true;
				} else if (currentQueryObject.c && Array.isArray(currentQueryObject.c)) {
					currentQueryObject.c.forEach((componentInstance) => {
						if (componentInstance.id) {
							additionalOptions[componentInstance.id] = componentInstance;
						}
					});
					shouldExecute = true;
				}

				if (shouldExecute) {
					executeAction(currentQueryObject, additionalOptions);
				}
			}
		}
	},

	purgeHistoryState: function() {
		var currentQueryObject = this.getQueryObject();

		//c should be an array.  If it is not, something is wrong, justt delete it.
		if (currentQueryObject.c && !Array.isArray(currentQueryObject.c)) {
			delete currentQueryObject.c;
		}

		var queryStringAltered = false;
		if (!currentQueryObject.c) {
			//This means we do not have multiple, just have the one
			if (!$(`[id="${currentQueryObject.id}"]`).length) {
				//And it is not on the page
				//	Delete all the properties that we set.
				delete currentQueryObject.id;
				delete currentQueryObject.limit;
				delete currentQueryObject.tangibleTypes;
				delete currentQueryObject.offset;
				delete currentQueryObject.sort;
				delete currentQueryObject.ascending;
				queryStringAltered = true;
			}
			//Otherwise, we do not have it in the history
		} else {
			//Check if it is in the c array.  If so, delete it
			for (var index = 0; index < currentQueryObject.c.length; index++) {
				if (!$(`[id="${currentQueryObject.c[index].id}"]`).length) {
					//We found one that is not on the page
					currentQueryObject.c.splice(index, 1);
					queryStringAltered = true;
					index--;
				}
			}
		}

		if (currentQueryObject.c && currentQueryObject.c.length === 1) {
			//We just have one now, so we can remove the 'c' notation
			currentQueryObject = currentQueryObject.c[0];
		}

		//We are replacing instead of pushing a new one because the pushing for the paging or sorting action would have already happened
		//	We are just cleaning up, if necessary.
		if (queryStringAltered) {
			history.replaceState(currentQueryObject, "", `?${QueryStringHelper.createQueryString(currentQueryObject)}`);
		}
	},

	replaceHistoryState: function(newQueryObject, title) {
		history.replaceState(newQueryObject, title || "", `?${QueryStringHelper.createQueryString(newQueryObject)}`);
	},

	updateHistoryStateAfterLoad: function (newQueryObject, updateId, afterCreateObjectLogic) {
		newQueryObject = ApiHelper.deleteUndefinedValues(newQueryObject || {});

		var currentQueryObject = this.getQueryObject();

		if ((typeof afterCreateObjectLogic === "function")) {
			afterCreateObjectLogic(currentQueryObject);
		}

		//c should be an array.  If it is not, something is wrong, just delete it.
		if (currentQueryObject.c && !Array.isArray(currentQueryObject.c)) {
			delete currentQueryObject.c;
		}

		if ((!currentQueryObject.id && !currentQueryObject.c) || currentQueryObject.id === newQueryObject.id) {
			//If we do not already have a component history or it is the same as the one we have
			Object.assign(currentQueryObject, newQueryObject);
		} else if (currentQueryObject.id && !currentQueryObject.c) {
			//We have one component history, but need to add a second one.  So go ahead and create a list named "c" (short name for constituent browser) and add both histories to it.
			currentQueryObject.c = [];
			currentQueryObject.c.push(ApiHelper.deleteUndefinedValues({
				ascending: currentQueryObject.ascending,
				id: currentQueryObject.id,
				offset: currentQueryObject.offset,
				searchId: currentQueryObject.searchId, //Used for sponsorshipSearch
				sort: currentQueryObject.sort
			}));
			delete currentQueryObject.id;
			delete currentQueryObject.limit;
			delete currentQueryObject.tangibleTypes;
			delete currentQueryObject.offset;
			delete currentQueryObject.sort;
			delete currentQueryObject.ascending;
			delete currentQueryObject.searchId; //Used for sponsorshipSearch
			currentQueryObject.c.push(newQueryObject);
		} else if (currentQueryObject.c) {
			//If we already have it, just replace it.
			var foundItem = false;
			for (var index = 0; index < currentQueryObject.c.length; index++) {
				if (currentQueryObject.c[index].id === newQueryObject.id) {
					//We found the same one
					currentQueryObject.c[index] = newQueryObject;
					foundItem = true;
				}
			}

			if (!foundItem) {
				currentQueryObject.c.push(newQueryObject);
			}
		}

		if (window.lastUpdateId !== updateId) {
			history.pushState(currentQueryObject, "", `?${QueryStringHelper.createQueryString(currentQueryObject)}`);
		} else {
			//We are replacing if we have more than one searchResults component on the page.  When both results come back, we do not want to add multiple history states.
			history.replaceState(currentQueryObject, "", `?${QueryStringHelper.createQueryString(currentQueryObject)}`);
		}
		window.lastUpdateId = updateId;
	}
};
